import React from 'react';
export function RegenerativeDifference() {
  const badges = ['100% Your Own Biology', 'Zero Foreign Substances', 'Clinically Proven'];
  return <section className="bg-white py-20 md:py-32 px-4 border-t border-divider" data-id="element-133">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-134">
        <span className="font-sans text-sm md:text-base text-sage uppercase tracking-[0.2em] mb-6 font-medium" data-id="element-135">
          The Most Natural Treatment In Aesthetics
        </span>

        <h2 className="font-serif text-3xl md:text-5xl text-espresso mb-8 leading-tight" data-id="element-136">
          We take what's already inside you — and put it exactly where it's
          needed.
        </h2>

        <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed mb-12 max-w-3xl" data-id="element-137">
          It starts with a simple blood draw. We refine it to concentrate your
          body's own growth factors — the same ones it uses to heal naturally.
          That concentrated power is delivered directly to your scalp,
          reactivating follicles that have gone quiet. No synthetic chemicals.
          No implants. Just your biology, working the way it was designed to.
        </p>

        <div className="flex flex-wrap justify-center gap-4" data-id="element-138">
          {badges.map((badge, index) => <div key={index} className="px-6 py-3 rounded-full border border-sage/30 bg-sage/5 text-espresso font-sans text-sm md:text-base font-medium tracking-wide" data-id="element-139">
              {badge}
            </div>)}
        </div>
      </div>
    </section>;
}